// src/utils/notificationBus.js
const notificationBus = {
  _handler: null,
  register(fn) { this._handler = fn; },
  open(type, filters) { this._handler?.(type, filters); },
};

export default notificationBus;